/**
 * 基础菜单 司机管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }"
        >首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>司机管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <div>
      <el-form :inline="true" :model="formInline" class="user-search">
        <el-form-item label="姓名：">
          <el-input
            size="small"
            v-model="formInline.name"
            placeholder="输入姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="工号：">
          <el-input
            size="small"
            v-model="formInline.jobNumber"
            placeholder="输入工号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号：">
          <el-input
            size="small"
            v-model="formInline.phoneNumber"
            placeholder="手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="驾驶证编号：">
          <el-input
            size="small"
            v-model="formInline.drivingNumber"
            placeholder="驾驶证编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            size="medium"
            type="primary"
            icon="el-icon-search"
            @click="search"
            >搜索</el-button
          >
          <el-button
            size="medium"
            type="primary"
            icon="el-icon-plus"
            @click="handleAdd()"
            >添加</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!--列表-->
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column
        align="center"
        header-align="center"
        prop="id"
        label="编号"
        width="80"
      ></el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="name"
        label="姓名"
        min-width="100"
      ></el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="jobNumber"
        label="工号"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="sex"
        label="性别"
        min-width="100"
      >
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="phoneNumber"
        label="手机号"
        min-width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="drivingNumber"
        label="驾驶证编号"
        min-width="210"
      >
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="driveType"
        label="准驾车型"
        min-width="200"
      >
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="remarks"
        label="备注"
        min-width="440"
      >
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="200"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button size="small" type="danger" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 添加界面 -->
    <el-dialog
      :title="addtitle"
      :visible.sync="addFormVisible"
      width="30%"
      @click="closeDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div style="margin-right: 5%">
        <el-form
          label-width="70px"
          :model="addForm"
          :rules="rules"
          ref="addForm"
        >
          <el-form-item label-width="100px" label="姓名" prop="name">
            <el-input
              size="small"
              v-model="addForm.name"
              auto-complete="off"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="工号" prop="jobNumber">
            <el-input
              size="small"
              v-model="addForm.jobNumber"
              auto-complete="off"
              placeholder="请输入工号"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="性别" prop="sex">
            <el-radio v-model="addForm.sex" label="男">男</el-radio>
            <el-radio v-model="addForm.sex" label="女">女</el-radio>
          </el-form-item>
          <el-form-item label-width="100px" label="手机号" prop="phoneNumber">
            <el-input
              size="small"
              v-model="addForm.phoneNumber"
              auto-complete="off"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label-width="100px"
            label="驾驶证编号"
            prop="drivingNumber"
          >
            <el-input
              size="small"
              v-model="addForm.drivingNumber"
              auto-complete="off"
              placeholder="请输入驾驶证编号"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="准驾车型" prop="driveType">
            <el-input
              size="small"
              v-model="addForm.driveType"
              auto-complete="off"
              placeholder="请输入准驾车型"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="备注" prop="remarks">
            <el-input
              type="textarea"
              size="small"
              v-model="addForm.remarks"
              auto-complete="off"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-left: 10%">
        <el-button
          size="mini"
          type="primary"
          :loading="loading"
          class="addtitle"
          @click="submitadd('addForm')"
          >保存</el-button
        >
        <el-button size="mini" @click="closeDialog('addForm')">取消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑界面 -->
    <el-dialog
      :title="edittitle"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div style="margin-right: 5%">
        <el-form
          label-width="70px"
          :model="editForm"
          :rules="rules"
          ref="editForm"
        >
          <el-form-item label-width="100px" label="姓名" prop="name">
            <el-input
              size="small"
              v-model="editForm.name"
              auto-complete="off"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="工号" prop="jobNumber">
            <el-input
              size="small"
              v-model="editForm.jobNumber"
              auto-complete="off"
              placeholder="请输入工号"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="性别" prop="sex">
            <el-radio v-model="editForm.sex" label="男">男</el-radio>
            <el-radio v-model="editForm.sex" label="女">女</el-radio>
          </el-form-item>
          <el-form-item label-width="100px" label="手机号" prop="phoneNumber">
            <el-input
              size="small"
              v-model="editForm.phoneNumber"
              auto-complete="off"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item
            label-width="100px"
            label="驾驶证编号"
            prop="drivingNumber"
          >
            <el-input
              size="small"
              v-model="editForm.drivingNumber"
              auto-complete="off"
              placeholder="请输入驾驶证编号"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="准驾车型" prop="driveType">
            <el-input
              size="small"
              v-model="editForm.driveType"
              auto-complete="off"
              placeholder="请输入准驾车型"
            ></el-input>
          </el-form-item>
          <el-form-item label-width="100px" label="备注" prop="remarks">
            <el-input
              size="small"
              type="textarea"
              v-model="editForm.remarks"
              auto-complete="off"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>

        <div style="margin-left: 10%">
          <el-button
            size="mini"
            type="primary"
            :loading="loading"
            class="edittitle"
            @click="submitForm('editForm')"
            >保存</el-button
          >
          <el-button size="mini" @click="closeDialog('editForm')"
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  driver_add,
  get_one,
  get_list,
  driver_edit,
  driver_del,
} from "../../api/driver/api";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false,
      tableData: [],
      addtitle: "添加",
      edittitle: "修改",
      addForm: {
        id: "",
        name: "",
        jobNumber: "",
        sex: "",
        phoneNumber: "",
        drivingNumber: "",
        driveType: "",
        remarks: "",
      },
      editForm: {
        id: "",
        name: "",
        jobNumber: "",
        sex: "",
        phoneNumber: "",
        drivingNumber: "",
        driveType: "",
        remarks: "",
      },
      // rules表单验证
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            pattern: /^[\u0391-\uFFE5]+$/,
            message: "请用车人姓名，如：李四",
            trigger: "blur",
          },
        ],
        jobNumber: [
          { required: true, len: 8, message: "请输入8位工号", trigger: "blur" },
          {
            pattern: /^-?[1-9]\d*$/,
            message: "工号为整数,如：85***378",
            trigger: "blur",
          },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        phoneNumber: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^[1][34578]\d{9}$/,
            message: "请输入正确的手机号，如：136****5645",
            trigger: "blur",
          },
        ],
        drivingNumber: [
          { required: true, message: "请输入驾驶证编号", trigger: "blur" },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的驾驶证编号，如：34222219********44",
            trigger: "blur",
          },
        ],
        driveType: [
          { required: true, message: "请输入准驾车型", trigger: "change" },
        ],
      },

      formInline: {
        id: "",
        name: "",
        jobNumber: "",
        sex: "",
        phoneNumber: "",
        drivingNumber: "",
        driveType: "",
        remarks: "",
        page: 1,
        limit: 10,
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取姓名表
    getdata() {
      // this.loading = true;
      get_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          // this.loading = false;
          this.tableData = res.data;
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res["count"];
        }else{
          this.$message.error(res["message"])
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getdata();
    },
    //显示添加界面
    handleAdd() {
      this.addFormVisible = true;
      this.addtitle = "添加";
      this.addForm.name = "";
      this.addForm.jobNumber = "";
      this.addForm.sex = "男";
      this.addForm.phoneNumber = "";
      this.addForm.drivingNumber = "";
      this.addForm.driveType = "";
      this.addForm.remarks = "";
    },
    //显示编辑界面
    handleEdit(row) {
      this.edittitle = "修改";
      get_one(row.id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data;
          this.editFormVisible = true;
        } else {
          this.$message.error(res["message"]);
        }
      });
    },
    //添加信息
    submitadd(addData) {
      this.$refs[addData].validate((valid) => {
        if (valid) {
          driver_add(this.addForm).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              this.addFormVisible = false;
              this.getdata();
              this.addForm = {};
            } else {
              this.$message.error(res["message"]);
              this.loading = false;
            }
          });
        } else {
          return false;
        }
      });
    },
    // 编辑页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          driver_edit(this.editForm).then((res) => {
            this.editFormVisible = false;
            this.loading = false;
            if (res["code"] === 0) {
              this.getdata();
              this.editForm = {};
              this.$message.success(res["message"]);
            } else {
              this.$message.error(res["message"]);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除
    handleDelete(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal:false,
        type: "warning",
      })
        .then(() => {
          driver_del(row.id).then((res) => {
            if (res["code"] === 0) {
              this.$message.success(res["message"]);
              if (this.tableData.length === 1) {
                if (this.formInline.page === 1) {
                  this.getdata();
                } else {
                  this.formInline.page = this.formInline.page - 1;
                  this.getdata();
                }
              } else {
                this.getdata();
              }
            } else {
              this.$message.error(res["message"]);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
      this.addFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 30px;
  width: 100%;
  height: 80px;
}
.userRole {
  width: 100%;
}
.search {
  margin-top: 20px;
  padding-left: 10px;
  border: 1px solid rgb(163, 226, 226);
}
.el-dialog .el-form {
  padding-left: 3%;
  padding-right: 10%;
}

.dialog {
  margin: auto;
}
.dialog-footer {
  margin: auto;
  text-align: center;
}

/* .el-dialog__body {
  padding-left: 3%;
  padding-right: 15%;
} */
</style>

 
 


// WEBPACK FOOTER //
// src/views/driver_mn/Driver_info.vue